import { NavController, NavParams, AlertController, LoadingController, ModalController, Platform } from "@ionic/angular";
import { Component, OnInit } from "@angular/core";
import { PlayerService } from "../../../providers/player-service/player-service";
import { PlayerGroupList, PlayerGroup } from "../../../data/player-data";
import { DeleteRoomModalComponent } from "../package-details/package-booking/delete-room-modal/delete-room-modal.component";

/*
 Generated class for the PlayerGroupsPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  templateUrl: 'player-groups.page.html',
  selector: 'player-groups-page',
  styleUrls: ['player-groups.page.scss'],
})
export class PlayerGroupsPage implements OnInit {
  refreshing: boolean = true;
  public playerGroupList: PlayerGroupList;
  public selectAndReturn: boolean = false;
  public selectedGroup: PlayerGroup;

  constructor(private nav: NavController,
    private modalCtl: ModalController,
    private alertCtl: AlertController,
    private loadingCtl: LoadingController,
    private navParams: NavParams,
    private platform: Platform,
    private playerService: PlayerService,
  ) {
    this.playerGroupList = {
      success: true,
      playerGroups: []
    };
    this.selectAndReturn = navParams.get("selectAndReturn");

  }

  ngOnInit() {
    this._refreshPlayerGroups();
  }

  onGroupSelection(event, group) {
    event.stopPropagation();
    // this.events.publish("playerGroupSelected", group);
    if (this.selectAndReturn) {
      this.modalCtl.dismiss(group);
      // this.nav.pop();
    }

  }

  async onDeleteFlightClick(event, group: PlayerGroup) {
    event.stopPropagation();
    // let confirm = await this.alertCtl.create({
    //   header: "Delete Player Group",
    //   message: "Do you want to delete the player group " + group.groupName + "?",
    //   backdropDismiss: true,
    //   buttons: [{
    //     text: "No",
    //     role: "cancel",
    //     handler: () => {
    //       confirm.dismiss();
    //       return false;
    //     }
    //   }, {
    //     text: "Yes",
    //     handler: () => {
    //       confirm.dismiss().then(() => {
    //         this.deleteGroup(group);
    //       });
    //       return false;
    //     }
    //   }]
    // });
    // return confirm.present();
    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop:true,
      mode:'ios',
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
        mode:'notification',
        header:'Delete Player Group',
        msg:"Do you want to delete the player group " + group.groupName + "?"
      }      
    });    
    modal.onDidDismiss().then((data)=>{
      if(data){
        if(data?.data === 'confirm'){         
          this.deleteGroup(group);
        }
      }
    })
    await modal.present();
  }

  async deleteGroup(group: PlayerGroup) {
    let loading = await this.loadingCtl.create({
      showBackdrop: false
    });
    loading.onDidDismiss().then((refresh: any) => {
      if (refresh)
        this._refreshPlayerGroups();
    });
    this.playerService.deletePlayerGroup(group.id)
      .subscribe((result: boolean) => {
        loading.dismiss(result);
      }, (error) => {
        loading.dismiss(false);
      });
    loading.present();
  }

  cancelGroup() {
    this.modalCtl.dismiss();
  }

  private _refreshPlayerGroups() {
    this.refreshing = true;
    this.playerService.getPlayerGroups()
      .subscribe((pgList: PlayerGroupList) => {
        this.playerGroupList = pgList;
        this.refreshing = false;
      }, (error) => {

      })
  }

  searchQuery: string = '';
  filteredGroups() {
    let _filtered = [];
    _filtered = this.playerGroupList?.playerGroups
    if(this.searchQuery?.length > 0){
      _filtered = this.playerGroupList.playerGroups.filter((pg: PlayerGroup) => {
        let _hasPlayers = pg.players?.some((p: any) => {
          return p.playerName.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0
        })
        return pg.groupName.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0 || _hasPlayers
      })
    }
    return _filtered;
  }
}
